export default function Stats() {
  const stats = [
    {
      number: "1000+",
      title: "Orders Completed",
      icon: "🏆",
    },
    {
      number: "24-48h",
      title: "Fast Turnaround",
      icon: "⚡",
    },
    {
      number: "100%",
      title: "Customer Satisfaction",
      icon: "⭐",
    },
    {
      number: "Nationwide",
      title: "Delivery",
      icon: "🚚",
    },
  ];

  return (
    <section className="bg-[#07111d] py-20">
      <div className="mx-auto max-w-7xl px-6">

        <div className="grid gap-8 md:grid-cols-4">

          {stats.map((item) => (
            <div
              key={item.title}
              className="rounded-3xl border border-sky-500/20 bg-slate-900 p-8 text-center transition-all duration-300 hover:-translate-y-2 hover:border-sky-400 hover:shadow-[0_0_35px_rgba(14,165,233,.25)]"
            >
              <div className="mb-4 text-5xl">
                {item.icon}
              </div>

              <h2 className="text-4xl font-black text-sky-400">
                {item.number}
              </h2>

              <p className="mt-3 text-gray-300">
                {item.title}
              </p>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}